<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="currentDate"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :id="id"
        v-model="datePresentation"
        readonly
        v-bind="attrs"
        v-on="on"
      >
        <template v-slot:prepend-inner>
          <v-btn icon small color="primary" elevation="0" @click="menu = true">
            <v-icon> bhi-calendar </v-icon>
          </v-btn>
        </template>
      </v-text-field>
      <label :for="id" v-if="label">{{ label }}</label>
    </template>
    <v-date-picker
      v-model="currentDate"
      no-title
      scrollable
      elevation="0"
      :min="allowOnlyFuture ? today : undefined"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">
        Cancel
      </v-btn>
      <v-btn text color="primary" @click="onConfirm">
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>
<script>
let today = new Date()
const dd = String(today.getDate()).padStart(2, '0')
const mm = String(today.getMonth() + 1).padStart(2, '0')
const yyyy = today.getFullYear()
today = `${yyyy}-${mm}-${dd}`

export default {
  name: 'DatePicker',
  props: {
    date: {
      type: [Date, String],
      default: () => '',
    },
    dateFormat: {
      type: String,
      default: 'MMMM Do, YYYY',
    },
    allowOnlyFuture: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: '',
    },
    id: {
      type: [Number, String],
      default: 'datePicker',
    },
  },
  data() {
    return {
      menu: false,
      currentDate: this.date,
      today,
    }
  },
  watch: {
    date(val) {
      if (val && this.$moment(val).format('YYYY-MM-DD') != this.currentDate) {
        this.currentDate = this.$moment(val).format('YYYY-MM-DD')
      }
      if (!val) {
        this.currentDate = null
      }
    },
  },
  computed: {
    datePresentation() {
      return this.currentDate
        ? this.$moment(this.currentDate).format(this.dateFormat)
        : 'Choose date'
    },
  },
  methods: {
    onConfirm() {
      this.$refs.menu.save(this.currentDate)
      this.$emit('input', this.$moment(this.currentDate).format())
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

label {
  font-weight: 700;
  font-size: 0.857rem;
  line-height: 1.6667;
  margin: 0;
  color: $bh-gray--2;
}
</style>
